import type { ColorPalettes } from 'src/theme/colors/index';

export interface ColorAliases {
  // Stacked Bar Widget
  stackedVeryNegative: string;
  stackedNegative: string;
  stackedNeutral: string;
  stackedPositive: string;
  stackedVeryPositive: string;

  // Doughnut Widget
  doughnutNeutral: string;
  doughnutPositive: string;
  doughnutVeryPositive: string;

  // Open Comments Widget
  commentNegative: string;
  commentNeutral: string;
  commentPositive: string;

  // Difference Widget
  differencePositive: string;
  differenceNeutral: string;
  differenceNegative: string;

  // Response Manager Widget
  responseManagerBars: string;

  // General Widget Colors
  generalVeryPositive: string;
  generalPositive: string;
  generalNeutral: string;
  generalNegative: string;
  generalVeryNegative: string;
}

/**
 * Special named colors that can be overwritten by the
 * customization without overriding the whole color palette.
 */
export const getColorAliases = (
  colorPalettes: ColorPalettes,
): ColorAliases => ({
  // Stacked Bar Widget
  stackedVeryNegative: colorPalettes.error[800],
  stackedNegative: colorPalettes.error[600],
  stackedNeutral: colorPalettes.secondary[500],
  stackedPositive: colorPalettes.tertiary[400],
  stackedVeryPositive: colorPalettes.tertiary[600],

  // Doughnut Widget
  doughnutNeutral: colorPalettes.neutral[100],
  doughnutPositive: colorPalettes.tertiary[400],
  doughnutVeryPositive: colorPalettes.tertiary[600],

  // Open Comments Widget
  commentNegative: colorPalettes.error[600],
  commentNeutral: colorPalettes.neutral[400],
  commentPositive: colorPalettes.success[600],

  // Difference Widget
  differenceNegative: colorPalettes.error[600],
  differenceNeutral: colorPalettes.neutral[700],
  differencePositive: colorPalettes.tertiary[400],

  // Response Manager Widget
  responseManagerBars: colorPalettes.secondary[400],

  // General Widget Colors
  generalVeryNegative: colorPalettes.error[800],
  generalNegative: colorPalettes.error[600],
  generalNeutral: colorPalettes.secondary[500],
  generalPositive: colorPalettes.tertiary[400],
  generalVeryPositive: colorPalettes.tertiary[600],
});

export default getColorAliases;
